var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ws-data-table-pagenate"},[_c('WsPagenate',{attrs:{"currentPage":_vm.currentPage,"lastPage":_vm.lastPage},on:{"pageto":function($event){return _vm.$_onPageto($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }